import { configureStore } from '@reduxjs/toolkit'
import stepSlice from '../Slice/stepSlice'
import selectedProjectSlice from '../Slice/selectedProjectSlice'
import indexStepSlice from '../Slice/indexStepSlice'
import selectedProductsSlice from '../Slice/selectedProductsSlice'

export const store = configureStore({
  reducer: {
    step : stepSlice,
    selectedProject : selectedProjectSlice,
    indexStep : indexStepSlice,
    selectedProducts : selectedProductsSlice
  },
})